import { orders } from "@wayke-se/ecom";
export const getOrderOptions = (data, callback) => {
    const request = orders.newOptionsRequest().forVehicle(data.vehicleId);
    if (data.dealerId)
        request.forDealer(data.dealerId);
    orders
        .getOptions(request.build())
        .then((response) => {
        callback(response);
    })
        .catch(callback);
};
